// extracted by mini-css-extract-plugin
export var gif = "_ie-0";